import { Paper, Tab, Tabs } from '@material-ui/core'
import { useContext, useEffect, useState } from 'react'
import MainContainer from '../../components/MainContainer'
import MainHeader from '../../components/MainHeader'

import ProtectedRoute from '../../components/ProtectedRoute'
import TabPanel from '../../components/TabPanel'

import CompaniesManager from '../../components/CompaniesManager'
import ContainersManager from '../../components/ContainersManager'
import DependenciesInfo from '../../components/DependenciesInfo'
import HelpsManager from '../../components/HelpsManager'
import PlansManager from '../../components/PlansManager'
import Options from '../../components/Settings/Options'
import PaymentGateway from '../../components/Settings/PaymentGateway'
import Service from '../../components/Settings/Service'
import SystemMessages from '../../components/Settings/SystemMessages'
import SettingsAuditLogs from '../../components/Settings/AuditLogs'
import Whitelabel from '../../components/Settings/Whitelabel'

import { toast } from 'react-toastify'
import { i18n } from '../../translate/i18n.js'

import useAuth from '../../hooks/useAuth.js'
import useCompanies from '../../hooks/useCompanies'
import useSettings from '../../hooks/useSettings'
import { SocketContext } from '../../context/Socket/SocketContext'

import OnlyForSuperUser from '../../components/OnlyForSuperUser'
import { useStyles } from './styles'

const SettingsCustom = () => {
  const classes = useStyles()
  const [tab, setTab] = useState('options')
  const [, setSchedules] = useState([])
  const [, setCompany] = useState({})
  const [, setLoading] = useState(false)
  const [currentUser, setCurrentUser] = useState({})
  const [settings, setSettings] = useState({})
  const [, setSchedulesEnabled] = useState(false)
  const [enableExperimental, setEnableExperimental] = useState(false)

  const { getCurrentUserInfo } = useAuth()
  const { find } = useCompanies()
  const { getAll: getAllSettings, getPublicSetting } = useSettings()
  const socketManager = useContext(SocketContext)

  useEffect(() => {
    const socket = socketManager.GetSocket()

    const onExperimentalSettings = data => {
      if (data?.key !== 'enableExperimental') {
        return
      }

      const enabled = data.value === 'enabled' || data.value === 'true'
      setEnableExperimental(enabled)

      if (!enabled && tab === 'systemMessages') {
        setTab('options')
      }
    }

    socket.on('experimentalSettings', onExperimentalSettings)

    return () => {
      socket.off('experimentalSettings', onExperimentalSettings)
    }
  }, [socketManager, tab])

  useEffect(() => {
    let mounted = true
    async function findData() {
      setLoading(true)
      try {
        const companyId = localStorage.getItem('companyId')
        const company = await find(companyId)
        const settingList = await getAllSettings()

        try {
          const expVal = await getPublicSetting('enableExperimental')
          if (mounted) {
            setEnableExperimental(expVal === 'enabled' || expVal === 'true')
          }
        } catch (err) {
          console.error('Erro ao carregar enableExperimental:', err)
        }

        if (!mounted) return

        setCompany(company)
        setSchedules(company.schedules)
        setSettings(settingList)

        if (Array.isArray(settingList)) {
          const scheduleType = settingList.find(d => d.key === 'scheduleType')
          if (scheduleType) {
            setSchedulesEnabled(scheduleType.value === 'company')
          }
        }

        const user = await getCurrentUserInfo()
        setCurrentUser(user)
      } catch (e) {
        toast.error(e)
      }
      setLoading(false)
    }
    findData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleTabChange = (event, newValue) => {
    async function findData() {
      setLoading(true)
      try {
        const companyId = localStorage.getItem('companyId')
        const company = await find(companyId)
        const settingList = await getAllSettings()
        setCompany(company)
        setSchedules(company.schedules)
        setSettings(settingList)

        if (Array.isArray(settingList)) {
          const scheduleType = settingList.find(d => d.key === 'scheduleType')
          if (scheduleType) {
            setSchedulesEnabled(scheduleType.value === 'company')
          }
        }

        const user = await getCurrentUserInfo()
        setCurrentUser(user)
      } catch (e) {
        toast.error(e)
      }
      setLoading(false)
    }
    findData()
    // eslint-disable-next-line react-hooks/exhaustive-deps

    setTab(newValue)
  }

  // const handleSubmitSchedules = async data => {
  //   setLoading(true)
  //   try {
  //     setSchedules(data)
  //     await updateSchedules({ id: company.id, schedules: data })
  //     toast.success('Horários atualizados com sucesso.')
  //   } catch (e) {
  //     toast.error(e)
  //   }
  //   setLoading(false)
  // }

  const isSuper = () => {
    return currentUser.super
  }

  const hasUserRole = roleName => {
    if (!currentUser) return false

    if (Array.isArray(currentUser.roles)) {
      return currentUser.roles.some(role => {
        if (typeof role === 'object' && role.role) {
          return role.role === roleName
        }

        if (typeof role === 'string') {
          return role === roleName
        }

        return false
      })
    }

    return currentUser.profile === roleName
  }

  const isAuditoriaOnlyView =
    hasUserRole('auditoria') && !isSuper() && currentUser.profile !== 'admin'

  useEffect(() => {
    if (isAuditoriaOnlyView && tab !== 'auditLogs') {
      setTab('auditLogs')
    }
  }, [isAuditoriaOnlyView, tab])

  return (
    <ProtectedRoute
      requiredRoles={['super', 'admin', 'gestor', 'auditoria']}
      fallbackPath="/tickets"
    >
      <MainContainer>
        <MainHeader
          title={i18n.t('settings.title')}
          description="Ajuste as configurações do sistema de acordo com as necessidades da sua empresa."
        // showTutorial
        // onTutorialClick={handleOpenTutorial}
        ></MainHeader>
        <Paper className={classes.mainPaper} elevation={1}>
          <Tabs
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="on"
            variant="scrollable"
            onChange={handleTabChange}
            className={classes.tab}
          >
            {!isAuditoriaOnlyView && (
              <Tab
                label={i18n.t('settings.Options.title')}
                value={'options'}
                className={classes.tabHeader}
              />
            )}
            {/* {schedulesEnabled && ( */}
            {/* <Tab
                label={i18n.t('settings.schedules.title')}
                value={'schedules'}
                className={classes.tabHeader}
              /> */}
            {/* )} */}
            {isSuper() ? (
              <Tab
                label={i18n.t('settings.Companies.title')}
                value={'companies'}
                className={classes.tabHeader}
              />
            ) : null}
            {isSuper() ? (
              <Tab
                label={i18n.t('settings.Plans.title')}
                value={'plans'}
                className={classes.tabHeader}
              />
            ) : null}
            {isSuper() ? (
              <Tab
                label={i18n.t('settings.Help.title')}
                value={'helps'}
                className={classes.tabHeader}
              />
            ) : null}
            {isSuper() ? (
              <Tab
                label={i18n.t('settings.Whitelabel.title')}
                value={'whitelabel'}
                className={classes.tabHeader}
              />
            ) : null}
            {isSuper() ? (
              <Tab
                // label={i18n.t('settings.PaymentGateways.title')}
                label="Pagamentos"
                value={'paymentGateway'}
                className={classes.tabHeader}
              />
            ) : null}
            {isSuper() ? (
              <Tab
                label="Provedor"
                value={'service'}
                className={classes.tabHeader}
              />
            ) : null}
            {isSuper() ? (
              <Tab
                label="Containers"
                value={'containers'}
                className={classes.tabHeader}
              />
            ) : null}
            {!isAuditoriaOnlyView && enableExperimental && (
              <Tab
                label={i18n.t('settings.SystemMessages.title')}
                value={'systemMessages'}
                className={classes.tabHeader}
              />
            )}
            {!isAuditoriaOnlyView && (
              <Tab
                label={i18n.t('settings.tabs.dependencies')}
                value={'dependencies'}
                className={classes.tabHeader}
              />
            )}
            <Tab
              label="Auditoria"
              value={'auditLogs'}
              className={classes.tabHeader}
            />
          </Tabs>
          <Paper className={classes.paper} elevation={0}>
            {/* <TabPanel
              className={classes.container}
              value={tab}
              name={'schedules'}
            >
              <SchedulesForm
                loading={loading}
                onSubmit={handleSubmitSchedules}
                initialValues={schedules}
                settings={settings}
              />
            </TabPanel> */}
            {!isAuditoriaOnlyView && (
              <>
                <OnlyForSuperUser
                  user={currentUser}
                  yes={() => (
                    <>
                      <TabPanel
                        className={classes.container}
                        value={tab}
                        name={'whitelabel'}
                      >
                        <Whitelabel settings={settings} />
                      </TabPanel>
                      <TabPanel
                        className={classes.container}
                        value={tab}
                        name={'paymentGateway'}
                      >
                        <PaymentGateway settings={settings} />
                      </TabPanel>

                      <TabPanel
                        className={classes.container}
                        value={tab}
                        name={'companies'}
                      >
                        <CompaniesManager />
                      </TabPanel>
                      <TabPanel
                        className={classes.container}
                        value={tab}
                        name={'plans'}
                      >
                        <PlansManager settings={settings} />
                      </TabPanel>
                      <TabPanel
                        className={classes.container}
                        value={tab}
                        name={'helps'}
                      >
                        <HelpsManager />
                      </TabPanel>
                      <TabPanel
                        className={classes.container}
                        value={tab}
                        name={'service'}
                      >
                        <Service
                          settings={settings}
                          scheduleTypeChanged={value =>
                            setSchedulesEnabled(value === 'company')
                          }
                        />
                      </TabPanel>
                      <TabPanel
                        className={classes.container}
                        value={tab}
                        name={'containers'}
                      >
                        <ContainersManager />
                      </TabPanel>
                    </>
                  )}
                />
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={'options'}
                >
                  <Options
                    settings={settings}
                    scheduleTypeChanged={value =>
                      setSchedulesEnabled(value === 'company')
                    }
                  />
                </TabPanel>
                {enableExperimental && (
                  <TabPanel
                    className={classes.container}
                    value={tab}
                    name={'systemMessages'}
                  >
                    <SystemMessages settings={settings} />
                  </TabPanel>
                )}
                <TabPanel
                  className={classes.container}
                  value={tab}
                  name={'dependencies'}
                >
                  <DependenciesInfo />
                </TabPanel>
              </>
            )}
            <TabPanel
              className={classes.container}
              value={tab}
              name={'auditLogs'}
            >
              <SettingsAuditLogs />
            </TabPanel>
          </Paper>
        </Paper>
      </MainContainer>
    </ProtectedRoute>
  )
}

export default SettingsCustom
